/* eslint-disable angular/component-name */
/* globals d3,nv */
angular.module('zc.zenclerkS')
  .component('widgetCumulativeConversion', {
    templateUrl: '/templates/zenclerk_s/directives/dashboard/cumulative_conversion_widget.html',
    bindings: {
      project: '<',
      month: '<'
    },
    controller($q, $translate, $element, ZcsIncentive, ZcsAccessStats, ZcsCampaignStats, ZcsOemService, currencies) {
      const vm = this;
      // TODO: get the color from classes
      // colorPrimary = angular.element(".chart-primary").css('color')
      // colorSecondary = angular.element(".chart-secondary").css('color')
      const colorPrimary = '#1DD5A3';
      const colorSecondary = '#775FD3';
      const region = vm.project.region;
      const currency = currencies[vm.project.currency];

      function formatFraction(number) {
        return number / (10 ** currency.fractionSize);
      }

      let dateRangeOfCurrentMonth = [];
      let today = moment.tz(region);

      this.$onInit = () => {
        vm.svgContainer = d3.select($element.find('.chart-cumulative-conversion')[0]).append('svg');

        vm.campaignConversions = [];
        vm.monthlyDateKeys = [];
        vm.revenueData = { incentives: [] };

        if(!vm.month) {
          vm.month = moment.tz(region).format('YYYY-MM');
        }

        vm.monthlyDateKeys = getMonthlyDateKeys(vm.month);
        let datesValueOf = _.map(vm.monthlyDateKeys, d => moment.tz(d, 'YYYY-MM-DD', region).valueOf());
        if(isCurrentMonth()) {
          dateRangeOfCurrentMonth = [
            _.head(datesValueOf),
            moment.tz(region).startOf('days').valueOf(),
          ];
        } else {
          dateRangeOfCurrentMonth = [
            _.head(datesValueOf),
            _.last(datesValueOf),
          ];
        }

        const startAt = moment.tz(vm.month, 'YYYY-MM', region).valueOf();
        const endAt = moment.tz(vm.month, 'YYYY-MM', region).endOf('month').valueOf();
        ZcsCampaignStats.find({
          apikey: vm.project.apikey,
          dimension: 'daily'
        }, {
          start_at: {
            $gte: startAt,
            $lt: endAt
          }
        }).then(res => {
          vm.revenueData = res;

          return ZcsAccessStats.getAccessStatsForSegment(vm.project.apikey, null, startAt, endAt);
        }).then(res => {
          vm.accessStats = res;

          return ZcsIncentive.all(vm.project.id);
        }).then(incentives => {
          vm.incentivesByCode = _.groupBy(incentives, d => d.coupon_code);

          createCumulativeGraph();
        });
      };

      // create cumulative graph
      function createCumulativeGraph() {
        if(vm.revenueData.length === 0) return;

        let totalConversionData = [];
        let couponCodeConversionData = [];

        let lastValueTotal = 0;
        let lastValueConversion = 0;
        let currentValueTotal = 0;
        let currentValueConversion = 0;

        _.each(vm.monthlyDateKeys, date => {
          if(moment.tz(date, region).isAfter(today)) {
            return;
          }

          let campaignData = _.filter(vm.revenueData, d => moment.tz(d.start_at, region).isSame(date, 'day'));
          const valueOfDate = moment.tz(date, 'YYYY-MM-DD', region).valueOf();

          if(campaignData.length) {
            currentValueConversion =
              lastValueConversion +
              _.sumBy(campaignData, 'effective_conversion_price');
            couponCodeConversionData.push([valueOfDate, currentValueConversion]);
            lastValueConversion = currentValueConversion;
          } else {
            couponCodeConversionData.push([valueOfDate, lastValueConversion]);
          }

          let totalData = _.find(vm.accessStats, d => moment.tz(d.start_at, region).isSame(date, 'day'));

          if(totalData) {
            if(campaignData.length) {
              currentValueTotal =
                lastValueTotal +
                totalData.conversion_price -
                _.sumBy(campaignData, 'effective_conversion_price');
            } else {
              currentValueTotal = lastValueTotal + totalData.conversion_price;
            }
            totalConversionData.push([valueOfDate, currentValueTotal]);
            lastValueTotal = currentValueTotal;
          } else {
            totalConversionData.push([valueOfDate, lastValueTotal]);
          }
        });

        nv.addGraph(() => {
          let chart = nv.models.stackedAreaChart()
            .margin({top: 0, right: 30, bottom: 30, left: 20})
            .interpolate('cardinal') // rounded line
            .x(d => d[0])
            .y(d => formatFraction(d[1]))
            .showControls(false)
            .xDomain(dateRangeOfCurrentMonth)
            .color([colorPrimary, colorSecondary]);

          chart.xAxis
            .tickFormat(d => moment.tz(d, region).format('MM/DD'));

          chart.yAxis
            .tickFormat(d => currency.symbol + d3.format(',f')(d) + currency.suffix);

          vm.svgContainer.datum([
            { key: $translate.instant('directives.dashboard.cumulativeConversionWidget.viaSales', { service: ZcsOemService.getName() }), values: couponCodeConversionData },
            { key: $translate.instant('directives.dashboard.cumulativeConversionWidget.otherSales'), values: totalConversionData }
          ])
            .call(chart);

          nv.utils.windowResize(chart.update);

          return chart;
        });
      }

      function getMonthlyDateKeys(month) {
        let lastDayOfMonth = moment.tz(vm.month, 'YYYY-MM', region).endOf('month').date();
        // _.range does not include the last value, so add +1
        let range = _.range(1, lastDayOfMonth + 1);
        return _.map(range, d => moment.tz(vm.month, 'YYYY-MM', region).date(d).format('YYYY-MM-DD'));
      }

      function isCurrentMonth() {
        return vm.month === moment.tz(region).format('YYYY-MM');
      }
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/cumulative_conversion_widget.js